import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { Field, propTypes as formPropTypes } from 'redux-form'
import { lpForm } from 'lp-form'
import { ButtonArea, SubmitButton } from 'lp-components'
import { PartnerAutoSuggestInput } from 'components'
import * as Types from 'types'
import { filterDestroyed } from 'utils'

const propTypes = {
  ...formPropTypes,
  partnershipOptions: PropTypes.arrayOf(Types.searchSuggestion),
  existingPartnerships: PropTypes.arrayOf(Types.schoolPartnershipType),
}

function AddPartnerForm({
  handleSubmit,
  submitting,
  partnershipOptions,
  existingPartnerships,
}) {
  const validateExistingPartnership = useCallback(
    (option) => {
      const activePartnerships = filterDestroyed(existingPartnerships)
      if (
        activePartnerships.some(
          ({ organizationId }) =>
            organizationId === Number(option?.id) &&
            option?.type === 'organization_inventory'
        ) ||
        activePartnerships.some(
          ({ teachingArtistId }) =>
            teachingArtistId === Number(option?.id) &&
            option?.type === 'teaching_artist_inventory'
        )
      )
        return 'Partnership already exists with this organization for the selected year'
    },
    [existingPartnerships]
  )

  return (
    <form onSubmit={handleSubmit}>
      <fieldset>
        <Field
          name="selectedOption"
          label="Enter an Organization or Teaching Artist Name"
          component={PartnerAutoSuggestInput}
          suggestions={partnershipOptions}
          validate={validateExistingPartnership}
        />
      </fieldset>
      <ButtonArea>
        <SubmitButton {...{ submitting, style: 'secondary' }}>
          Add Partner
        </SubmitButton>
      </ButtonArea>
    </form>
  )
}

AddPartnerForm.propTypes = propTypes

export default compose(
  lpForm({
    name: 'school-add-partner',
    constraints: {
      organizationId: {
        presence: { message: '^Organization selection cannot be blank' },
      },
    },
  })
)(AddPartnerForm)
